import {
  cardsDataTransformer,
  projectWiseRevenueTransformer,
  userKpiTransformer,
  callScoringBreakdownTransformer,
  analyticsTransformer,
} from "./transformResponse/aiCallAnalysisTransformer"
import parentApi from "store/parentApi"
import { convertQueryObjToString } from "utils"
import staffListTransformer from "features/shared/api/transformResponse/staffListTransformer"

const AiCallAnalysisApi = parentApi.injectEndpoints({
  endpoints: build => ({
    getAiCallAnalysisUserKPI: build.query({
      query: params => `/reports/v2/ai_analysis_report?${convertQueryObjToString({ ...params })}`,
      transformResponse: response => userKpiTransformer(response),
      providesTags: ["ai-call-analysis-reports-user-kpi"],
    }),

    getAiCallAnalysisComparison: build.query({
      query: params => `/reports/v2/ai_analysis_report?${convertQueryObjToString({ ...params })}`,
      transformResponse: response => analyticsTransformer(response),
      providesTags: ["ai-call-analysis-reports-user-kpi"],
    }),

    getAiCallAnalysisStaff: build.query({
      query: ({ userId, ...restParams }) =>
        `/users/reportees/${userId}?teamTypeKeys=sales,secondarySales,acquisition,salesaff,afn_i_affiliates_tele_development,afn_i_affiliates_client_servicing,telesales,support,afn_i_affiliates_client_servicing&hierarchy=true&module=reports&subModule=aiAnalysisReport&${convertQueryObjToString(
          restParams
        )}`,
      transformResponse: response => staffListTransformer(response),
    }),

    getAiCallCardsData: build.query({
      query: params => `/reports/v2/ai_analysis_report?${convertQueryObjToString({ ...params })}`,
      transformResponse: response => cardsDataTransformer(response),
    }),

    getCallTypeDistribution: build.query({
      query: params => `/reports/v2/ai_analysis_report?${convertQueryObjToString({ ...params })}`,
      transformResponse: response => projectWiseRevenueTransformer(response),
    }),

    getCallScoringBreakdown: build.query({
      query: params => `/reports/v2/ai_analysis_report?${convertQueryObjToString({ ...params })}`,
      transformResponse: response => callScoringBreakdownTransformer(response),
    }),
  }),
  overrideExisting: false,
})

export const {
  useGetAiCallAnalysisUserKPIQuery,
  useLazyGetAiCallAnalysisComparisonQuery,
  useLazyGetAiCallAnalysisStaffQuery,
  useGetAiCallCardsDataQuery,
  useGetCallTypeDistributionQuery,
  useGetCallScoringBreakdownQuery,
} = AiCallAnalysisApi
